export const roundToPrecision = (value: number | null, precision: number): number | null => {
  if (!value) return null;
  const factor = Math.pow(10, precision);
  return Math.round(value * factor) / factor;
};
